import React from 'react';
import { PageLoadingContainer, LoadingDirective, Loader, Svg, CircleBottomLayer, CircleMiddleLayer, CircleTopLayer, CustomParagraphMd } from './styles.js';

function PageLoading({ message }) {
    const messageNeededSpace = message && (message === null || message === void 0 ? void 0 : message.length) > 28
        ? Math.round(message.length / 28) * 5 + 94
        : 94;
    return (React.createElement(PageLoadingContainer, null,
        React.createElement("span", { "data-testid": "olist-page-loading" },
            React.createElement(LoadingDirective, null,
                React.createElement(Loader, { style: message ? { top: `-${messageNeededSpace}px` } : {} },
                    React.createElement(Svg, null,
                        React.createElement(CircleBottomLayer, { cx: "64", cy: "64", r: "30", fill: "none" })))),
            React.createElement(LoadingDirective, null,
                React.createElement(Loader, { style: message ? { top: `-${messageNeededSpace}px` } : {} },
                    React.createElement(Svg, null,
                        React.createElement(CircleMiddleLayer, { cx: "64", cy: "64", r: "30", fill: "none" })))),
            React.createElement(LoadingDirective, null,
                React.createElement(Loader, { style: message ? { top: `-${messageNeededSpace}px` } : {} },
                    React.createElement(Svg, null,
                        React.createElement(CircleTopLayer, { cx: "64", cy: "64", r: "30", fill: "none" }))))),
        message && React.createElement(CustomParagraphMd, null, message)));
}

export { PageLoading as default };
